module.exports = __webpack_public_path__ + "img/20250827_Laurenz-19.56ca24c3.jpg";